import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-scroll-indicator',
    imports: [CommonModule, MatIcon],
    templateUrl: './scroll-indicator.component.html',
    styles: `
    :host {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      display: block;
      width: 100%;
      height: 2rem;
    }
  `
})
export class ScrollIndicatorComponent {
  @Input() public show = false;
  @Input() public label = 'more messages';
}
